import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from 'src/lib/utils';

interface MartReportFilterSelectProps {
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
  active?: boolean;
  className?: string;
  'aria-label'?: string;
}

export function MartReportFilterSelect({
  value,
  onChange,
  children,
  active = false,
  className,
  'aria-label': ariaLabel,
}: MartReportFilterSelectProps) {
  return (
    <div className={cn('relative min-w-0', className)}>
      <select
        aria-label={ariaLabel}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={cn(
          'w-full min-w-0 appearance-none truncate rounded-lg border-[1.5px] bg-white py-2 pl-3 pr-9 text-[13px] font-semibold transition-colors',
          active
            ? 'border-[#2563EB] bg-[#EFF6FF] text-[#2563EB]'
            : 'border-[#D9DBE3] text-[#5E6278] hover:border-[#B8BBCA] hover:text-[#0D0F1A]',
        )}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        strokeWidth={2.5}
        className={cn(
          'pointer-events-none absolute right-3 top-1/2 h-[13px] w-[13px] -translate-y-1/2',
          active ? 'text-[#2563EB]' : 'text-[#8A8EA0]',
        )}
      />
    </div>
  );
}
